import React from "react";
import { newContextComponents } from "@drizzle/react-components";
import { Table } from 'react-bootstrap';

import { Web3StatusContext } from "../../../contexts/Web3StatusContext";
import TransactionStatus from '../../TransactionStatus'

import contractABI from '../../../contracts/IERC20.json'
var IERC20ContractABI = require('../../../contracts/IERC20.json');

const { AccountData, ContractData, ContractForm } = newContextComponents;

class Approve extends React.Component {
  static contextType = Web3StatusContext;

  state = {
    amount: 0,
    tokenAddress: null,
    stackId: -1,
  };

  mySubmitHandler = (event) => {
    event.preventDefault();
    if(this.context.activeAccount == null) {
      console.log('no active account to approve');
      return;
    }
    const { drizzle } = this.props;
    const { GAMEFOREST, GAMEFORESTSale } = drizzle.contracts;

    var amount = this.context.web3.utils.toWei(this.state.amount.toString(), "ether");

    console.log(9);
    
    var tokenContract = new this.context.web3.eth.Contract(contractABI.abi, this.state.tokenAddress);

    var contractConfig = {
      contractName: this.state.tokenAddress,
      web3Contract: tokenContract
    };
    var events = [];

    if(drizzle.contracts[this.state.tokenAddress] === undefined)
      drizzle.addContract(contractConfig, events);

    const stackId = drizzle.contracts[this.state.tokenAddress].methods.approve.cacheSend
        (GAMEFORESTSale.address, amount, {from: this.context.activeAccount});

    this.setState({ stackId: stackId });
  }

  myAmountChangeHandler = (event) => {
    let { value } = event.target;
    const inputAmount = value;
    this.setState({amount: inputAmount});
  }

  myChangeHandler = (event) => {
    let { value } = event.target;
    const inputAddress = value;
    this.setState({tokenAddress: inputAddress});
  }

  // destructure drizzle and drizzleState from props
  render() {
    var statusMsg = '';
    if (this.state.stackId >= 0) {
      statusMsg = (
        <TransactionStatus
          drizzle={this.props.drizzle}
          drizzleState={this.props.drizzleState}
          stackId={this.state.stackId}
        >

        </TransactionStatus>
      );
    }

    var disabled = this.context.activeAccount == null;

    var form = (
    <form onSubmit={this.mySubmitHandler}>
        {statusMsg}<br/>
        Address:<br/>
        <input
        onChange={this.myChangeHandler}
        />
        Amount:<br/>
        <input
          type="number"
          value={this.state.amount}
          onChange={this.myAmountChangeHandler}
        />
        <br/>
        <input
        type='submit'
        value="Approve"
        disabled={disabled}
        />
        <br/>
    </form>
    );

    return (
      <div>
        {form}
      </div>
    );
  }
};

export default Approve;
